import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Label,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  Button,
} from "reactstrap";
import { navItems } from "./LayoutMenuData";
import CreateFolder from "../../Components/Common/LayeredNavComponent/CreateFolder";
import { useLocation } from "react-router-dom";

const LayeredNavigation = ({ direction }) => {
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [expandedMenuId, setExpandedMenuId] = useState(null);
  const [expandedSubMenuId, setExpandedSubMenuId] = useState(null);
  const [expandedSubMenuL2Id, setExpandedSubMenuL2Id] = useState(null);

  const location = useLocation();
  const currentRoute = location?.pathname;

  const toggleDropdown = (itemId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [itemId]: !prevState[itemId],
    }));
  };

  const toggleMenu = (itemId) => {
    setExpandedMenuId((prevId) => (prevId === itemId ? null : itemId));
    setExpandedSubMenuId(null);
    setExpandedSubMenuL2Id(null);
  };

  const toggleSubMenu = (itemId) => {
    setExpandedSubMenuId((prevId) => (prevId === itemId ? null : itemId));
    setExpandedSubMenuL2Id(null);
  };

  const toggleSubMenuL2 = (itemId) => {
    setExpandedSubMenuL2Id((prevId) => (prevId === itemId ? null : itemId));
  };

  const [showModal, setShowModal] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);

  const handleActionClick = (action) => {
    if (action.label === "Delete") {
      setSelectedAction(action);
      setShowModal(true);
    } else {
      // Handle other actions if needed
      console.log(`Action selected: ${action.label}`);
    }
  };

  const handleConfirmDelete = () => {
    if (selectedAction) {
      console.log(`Confirmed delete for: ${selectedAction.label}`);
      // Add your delete logic here
    }
    setShowModal(false);
    setSelectedAction(null);
  };

  const renderDropdown = (dropdownItems, itemId) => (
    <Dropdown
      isOpen={dropdownOpen[itemId]}
      toggle={() => toggleDropdown(itemId)}
      direction={direction}
      className="actionContain position-absolute top-50 end-0 translate-middle-y ms-auto me-4 z-1"
    >
      <DropdownToggle className="bg-transparent border-0 p-0 shadow-none actionBtn">
        <i className="bx bx-dots-horizontal-rounded"></i>
      </DropdownToggle>
      <DropdownMenu>
        {dropdownItems.map((dropdownAction) => (
          <DropdownItem
            key={dropdownAction.label}
            className={`fs-13 d-flex align-items-center gap-1 ${dropdownAction.color}`}
            onClick={() => handleActionClick(dropdownAction)}
          >
            <i className={dropdownAction.icon}></i>
            {dropdownAction.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );

  const renderNavItem = (navItem) => (
    <div key={navItem.id} className="navBar">
      <div
        className={`position-relative subNavBarL px-2 py-2 ${
          currentRoute === navItem.path ? "active" : ""
        }`}
      >
        <Link
          to={navItem.path}
          className="d-flex align-items-center justify-content-left gap-2 fs-14 rounded-3 position-relative"
          onClick={() => toggleMenu(navItem.id)}
        >
          <i
            className={`fs-18 lh-sm ${
              currentRoute === navItem.path ? navItem.iconActive : navItem.icon
            }`}
          ></i>
          {navItem.label}
        </Link>
        {navItem.dropdownItems &&
          renderDropdown(navItem.dropdownItems, navItem.id)}
      </div>
      {expandedMenuId === navItem.id &&
        navItem.subItems &&
        renderSubMenu(navItem.subItems)}
    </div>
  );

  const renderSubMenu = (subItems) => (
    <div className="subMenu">
      {subItems.map((subItem) => (
        <div key={subItem.id} className="position-relative subNavBar">
          <div
            className={`position-relative subNavBarL1 px-3 py-2 ${
              expandedSubMenuId === subItem.id ? "active" : ""
            }`}
          >
            <Link
              to={subItem.path}
              className="d-flex align-items-center justify-content-left gap-2 fs-14 rounded-3"
              onClick={() => toggleSubMenu(subItem.id)}
            >
              <i
                className={`fs-18 lh-sm ${
                  expandedSubMenuId === subItem.id
                    ? subItem.iconActive1
                    : subItem.icon1
                }`}
              ></i>
              {subItem.label}
            </Link>
            {subItem.dropdownItems &&
              renderDropdown(subItem.dropdownItems, subItem.id)}
          </div>
          {expandedSubMenuId === subItem.id &&
            subItem.subItems_l2 &&
            renderSubMenuL2(subItem.subItems_l2)}
        </div>
      ))}
    </div>
  );

  const renderSubMenuL2 = (subItemsL2) => (
    <div className="subMenuL2">
      {subItemsL2.map((subItemL2) => (
        <div
          key={subItemL2.id}
          className={`position-relative subNavBarL2 px-4 py-2 ${
            expandedSubMenuL2Id === subItemL2.id ? "active" : ""
          }`}
        >
          <Link
            to={subItemL2.path}
            className="d-flex align-items-center justify-content-left gap-2 fs-14 rounded-3"
            onClick={() => toggleSubMenuL2(subItemL2.id)}
          >
            <i
              className={`fs-18 lh-sm ${
                expandedSubMenuL2Id === subItemL2.id
                  ? subItemL2.iconActive2
                  : subItemL2.icon2
              }`}
            ></i>
            {subItemL2.label}
          </Link>
          {subItemL2.dropdownItems &&
            renderDropdown(subItemL2.dropdownItems, subItemL2.id)}
        </div>
      ))}
    </div>
  );

  return (
    <>
      <aside className="border-end min-h-100">
        <div className="d-flex flex-column navContain w-100 overflow-y-auto">
          <nav className="customNav d-flex flex-column gap-1 border-bottom py-3">
            <Link
              to="/dashboard"
              className="d-flex align-items-center justify-content-left gap-2 px-3 py-2 fs-14 rounded-3"
            >
              <i className="bx bx-menu-alt-right fs-18"></i> Dashboard
            </Link>
          </nav>
          {navItems.map((section) => (
            <nav className="customNav border-bottom py-2" key={section.id}>
              <div className="folderName d-flex justify-content-between align-items-center px-2">
                <Label className="fs-10 text-muted mb-0 fw-bold">
                  {section.title}
                </Label>
                {section.addFolder && <CreateFolder />}
              </div>
              {section.navList.map(renderNavItem)}
            </nav>
          ))}
        </div>
      </aside>

      <Modal
        isOpen={showModal}
        toggle={() => setShowModal(false)}
        backdrop="static"
      >
        <div className="modal-header">
          <h6 className="modal-title">Confirm Deletion</h6>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          Are you sure you want to delete this item?
        </div>
        <div className="modal-footer">
          <Button
            size="sm"
            outline
            color="dark"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>
          <Button
            size="sm"
            outline
            color="danger"
            onClick={handleConfirmDelete}
          >
            Delete
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default LayeredNavigation;
